
const initialState = {
  rateLimitRemaining: 0,
  btcPrice: null,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (action.type) {
    case 'SET_BALANCE': {
      return {
        ...state,
        btcPrice: payload.btcPrice,
      }
    }
    case 'RATE_LIMIT_REMAINING':
      return {
        ...state,
        rateLimitRemaining: payload.rateLimitRemaining,
      };
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/app/state/reducers/app.reducer.js